// Modules
import React, { ReactNode } from 'react'

// Components
import { DefaultTemplate } from '../DefaultTemplate'
import { MobileServiceTemplate } from '../MobileServiceTemplate'
import { useCustomLayoutStore } from 'redesign/store'
import { TemplateSingleBrand } from '../TemplateSingleBrand'
import { TemplateNewLogin } from '../TemplateNewLogin'
import { TemplateABTest } from '../TemplateABTest'
import { CurrentLaboratoryType } from 'typings/auth'
import { STORAGE_CURRENT_LABORATORY } from 'constants/storageKeys'

interface TemplateContainerProps {
    children: ReactNode
    renderHeader?: boolean
}

enum LayoutType {
    DEFAULT = 'default',
    BRAND_EMPHASIS = 'brandEmphasis',
    NEW_LOGIN = 'newLogin',
    SINGLE_BRAND = 'singleBrand',
    MOBILE_SERVICE = 'mobileService',
}

export const CustomTemplateSwitcher = ({ children, renderHeader }: TemplateContainerProps) => {
    const { activeLayout } = useCustomLayoutStore()
    const currentLaboratory: CurrentLaboratoryType = JSON.parse(sessionStorage.getItem(STORAGE_CURRENT_LABORATORY)!) || null
    const currentLayout = currentLaboratory?.layout || null

    if (!activeLayout) {
        return <>{children}</>
    }

    if (activeLayout?.mobileService) {
        return <MobileServiceTemplate>{children}</MobileServiceTemplate>
    }

    if (currentLayout === LayoutType.DEFAULT) {
        return <DefaultTemplate renderHeader={renderHeader}>{children}</DefaultTemplate>
    }

    if (currentLayout === LayoutType.BRAND_EMPHASIS) {
        return <TemplateNewLogin renderTemplateLogoNav={false}>{children}</TemplateNewLogin>
    }

    if (currentLayout === LayoutType.NEW_LOGIN) {
        return <TemplateABTest renderTemplateLogoNav={false}>{children}</TemplateABTest>
    }

    if (currentLayout === LayoutType.SINGLE_BRAND) {
        return <TemplateSingleBrand renderTemplateLogoNav={false}>{children}</TemplateSingleBrand>
    }

    return <DefaultTemplate renderHeader={renderHeader}>{children}</DefaultTemplate>
}
